<!-- DefaultPicker -->
<template>
  <van-popup position="bottom" v-model="show">
    <van-picker
      :columns="columns"
      show-toolbar
      @confirm="onConfirm"
      @cancel="onCancel"
      @change="onChange"
    />
  </van-popup>
</template>

<script>
import { Picker } from 'vant';

export default {
  name: 'DefaultPicker',
  components: {
    [Picker.name]: Picker
  },
  data () {
    return {
      show: false
    };
  },
  props: {
    columns: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  methods: {
    onConfirm(value, index) {
      this.$emit('onConfirm', {value, index})
      this.show = false
    },
    onChange(picker, value, index) {
      this.$emit('onChange', {value, index})
    },
    onCancel() {
      this.$emit('onCancel')
      this.show = false
    },
  },
}

</script>